import axios from 'axios';

export default {
  history: (params = {}, config = {}) => axios.get('imports', { params, ...config }),
  detail: (importId, config = {}) => axios.get(`imports/${importId}`, config),
  downloadDocument: (importId, fileId, config = {}) => axios.get(`imports/${importId}/files/${fileId}/download`, {
    responseType: 'blob',
    rawResponse: true,
    ...config,
  }),
  rollback: (importId, payload = {}, config = {}) => axios.post(`imports/${importId}/rollback`, payload, config),
};
